import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { API_ENDPOINTS } from '../../shared/constants/api.constants';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpEvent, HttpHandlerFn, HttpRequest, HttpHeaders } from '@angular/common/http'
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
export interface ValidatorConfig {
  validators: ValidatorFn[];
  errorMessages: { [key: string]: string }; // key 為 validator 的名稱，如 'required' 或 'maxlength'
  placeholder?: string;
}
@Injectable({
  providedIn: 'root'
})

export class FormsService {

  workloadList: string[] = ['個人相關過勞分量表', '工作相關過勞分量表']
     healthTitles: { [key: number]: string } = {
      0: '健康背景',
      1: '服用藥物與手術史',
      2: '生活習慣',
      3: '其他資訊',
      4: '作業經歷'
    };
  constructor(
    private http: HttpClient,
  ) { }
  // 骨骼表使用 Subject 或 BehaviorSubject 來傳遞資料
  private painDataSubject = new BehaviorSubject<any[]>([]);
  //判斷User 骨骼表有沒有選擇
  private hasSelectPain = new BehaviorSubject<boolean>(false)
  // 使用loading 狀態  來傳遞資料
  private loadingSubject = new BehaviorSubject<boolean>(false);
  // 健調表填寫狀態  傳遞資料
  private healthCheckLoadingSubject = new BehaviorSubject<boolean>(false);

  // 骨骼表暴露為 Observable 供 FormsComponent 訂閱
  painData$ = this.painDataSubject.asObservable();
  // loading狀態暴露為 Observable 供 FormsComponent 訂閱
  loading$ = this.loadingSubject.asObservable();
  // 健調表填寫狀態暴露為 Observable 供 FormsComponent 訂閱
  healthCheckLoading$ = this.healthCheckLoadingSubject.asObservable();
  //如已選擇提供給FormsComponent訂閱
  hasPainData$ = this.hasSelectPain.asObservable()

  // 供 BodyPainSelectorComponent 呼叫來更新資料
  updatePainData(data: any[]) {
    this.painDataSubject.next(data);
  }
  // 供 BodyPainSelectorComponent 提示已選擇資料
  hasOrNotPain(data: boolean) {
    this.hasSelectPain.next(data)
  }
  setLoading(isLoading: boolean) {
    this.loadingSubject.next(isLoading);
  }
  // // 健調表填寫狀態呼叫更新預約中心狀態
  setHealthCheckStatus(status: boolean) {
    this.healthCheckLoadingSubject.next(status);
  }

  // 讓 Component 可以直接拿目前的快照
  getPainDataValue() {
    return this.painDataSubject.getValue();
  }
  //獲取問卷數據的 API 請求
  getQuestionnaireData(questionnaireId: any): Observable<any> {
    return this.http.post(API_ENDPOINTS.DOWNLOAD_QUESTIONNAIRE_RESPONSES, questionnaireId

    );
  }

  //回傳問卷數據的 API
  insertAnswerData(answerData: any): Observable<any> {
    return this.http.post(API_ENDPOINTS.SUBMIT_QUESTIONNAIRE, answerData);
  }

  //回傳問卷並拿取電簽API
  getConsentsData(answerData: any): Observable<any> {
    return this.http.post(API_ENDPOINTS.GET_CONSENTS, answerData)
  }
  // 模擬提獲取骨骼問卷數據的 API 請求
  getBoneFormsData(questionnaireId: string): Observable<any> {
    return this.http.get('/member/getBoneFormsData', {
      params: { questionnaireId }
    })
  }

  // 自定義多選必填驗證器 (修正 TS2366 報錯)
  private requiredArrayValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    return (Array.isArray(value) && value.length > 0) ? null : { required: true };
  };
  /**
 * 根據 ID 取得對應的 Validators
 */
  /**
   * 供 Component 呼叫：透過 ID 獲取預設規則
   */
  getRegisteredValidators(questionId: number): ValidatorConfig | null {
    return this.questionValidatorRegistry[questionId] || null;
  }

  async hasCamera(): Promise<boolean> {
    try {
      // 取得所有媒體設備
      const devices = await navigator.mediaDevices.enumerateDevices();

      // 過濾出視訊輸入設備（鏡頭）
      const videoDevices = devices.filter(device => device.kind === 'videoinput');

      return videoDevices.length > 0;
    } catch (err) {
      console.error('無法獲取設備清單:', err);
      return false;
    }
  }
  public readonly questionValidatorRegistry: { [key: number]: ValidatorConfig } = {
    2: {
      validators: [Validators.required,Validators.maxLength(300)],
      errorMessages: { maxlength: '最多只能輸入300個字' }
    },
    11: {
      validators: [Validators.required],
      errorMessages: { required: '請至少選擇一項',}
    },
    13: {
      validators: [Validators.required],
      errorMessages: { required: '請至少選擇一項' }
    },
    17: {
      validators: [Validators.required],
      errorMessages: { required: '此欄位必輸!' },
      placeholder:'如無請輸入:無'
    },
    18: {
      validators: [Validators.required],
      errorMessages: { required: '此欄位必輸!' },
      placeholder:'如無請輸入:無'
    },
    19: {
      validators: [Validators.required],
      errorMessages: { required: '此欄位必輸!' },
      placeholder:'如無請輸入:無'
    },
    20: {
      validators: [Validators.required],
      errorMessages: { required: '此欄位必輸!' },
      placeholder:'如無請輸入:無'
    },
    21: {
      validators: [Validators.required],
      errorMessages: { required: '此欄位必輸!' },
      placeholder:'如無請輸入:無'
    },
    24: {
      validators: [Validators.required,Validators.min(0),Validators.max(100)],
      errorMessages: { min: '不可為負數!', max: '請輸入數字1~100!' },
      placeholder:'請輸入數字'
    },
    25: {
      validators: [Validators.required,Validators.min(0),Validators.max(100)],
      errorMessages: { min: '不可為負數!', max: '請輸入數字1~100!' },
      placeholder:'請輸入數字'
    },
    26: {
      validators: [Validators.required,Validators.min(0),Validators.max(300)],
      errorMessages: { min: '不可為負數!', max: '請輸入數字1~300!' },
      placeholder:'請輸入數字'
    },
    27: {
      validators: [Validators.required,Validators.min(0),Validators.max(300)],
      errorMessages: { min: '不可為負數!', max: '請輸入數字1~300!' },
      placeholder:'請輸入數字'
    },
    486: {
      validators: [Validators.required,Validators.min(1),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!',max:'數字最大為99!' },
      placeholder:'請輸入數字'
    },
    487: {
      validators: [Validators.required,Validators.min(1),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!',max:'數字最大為99!' },
      placeholder:'請輸入數字'
    },
    488: {
      validators: [Validators.required,Validators.min(0),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為0!',max:'數字最大為99!' },
      placeholder:'請輸入數字'
    },
    489: {
      validators: [Validators.required,Validators.min(0),Validators.max(11)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為0!' ,max:'數字最大為11!'},
      placeholder:'請輸入數字'
    },
    491: {
      validators: [Validators.required,Validators.min(1),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!',max:'數字最大為99!' },
      placeholder:'請輸入數字'
    },
    492: {
      validators: [Validators.required,Validators.min(1),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!',max:'數字最大為99!' },
      placeholder:'請輸入數字'
    },
    493: {
      validators: [Validators.required,Validators.min(0),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為0!',max:'數字最大為99!' },
      placeholder:'請輸入數字'
    },
    494: {
      validators: [Validators.required,Validators.min(0),Validators.max(11)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為0!' ,max:'數字最大為11!'},
      placeholder:'請輸入數字'
    },
    496: {
      validators: [Validators.required,Validators.min(1),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!',max:'數字最大為99!' },
      placeholder:'請輸入數字'
    },
    497: {
      validators: [Validators.required],
      errorMessages: { required: '此欄位必輸!' },
      placeholder:'請輸入種類'
    },
    498: {
      validators: [Validators.required,Validators.min(1),Validators.max(999)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!' ,max:'數字最大為999!'},
      placeholder:'請輸入數字'
    },
    499: {
      validators: [Validators.required,Validators.min(0),Validators.max(99)],
      errorMessages: { required: '此欄位必輸!' ,min: '數字最少為0!',max:'數字最大為99!'},
      placeholder:'請輸入數字'
    },
    500: {
      validators: [Validators.required,Validators.min(0),Validators.max(11)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為0!' ,max:'數字最大為11!'},
      placeholder:'請輸入數字'
    },
    530: {
      validators: [Validators.required,Validators.min(1),Validators.max(999)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!' ,max:'數字最大為999!'},
      placeholder:'請輸入數字'
    },
    531: {
      validators: [Validators.required,Validators.min(1),Validators.max(999)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!' ,max:'數字最大為999!'},
      placeholder:'請輸入數字'
    },
    533: {
      validators: [Validators.required,Validators.min(1),Validators.max(24)],
      errorMessages: { required: '此欄位必輸!',min: '數字最少為1!' ,max:'數字最大為24!'},
      placeholder:'請輸入數字'
    },
  };
}
